<template>
  <router-view/>
</template>

<script>
export default {
  name: 'CarMain'
}
</script>

<style scoped>

</style>
